// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flags img {
  vertical-align: middle;
  margin-right: 8px;
}
.flags .mat-menu-item,
.flags .mat-mdc-menu-item {
  height: 36px;
  line-height: 36px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/flags-menu/flags-menu.component.scss"],"names":[],"mappings":"AAKI;EACI,sBAAA;EACA,iBAAA;AAJR;AAOI;;EAEI,YAAA;EACA,iBAAA;EACA,eAAA;AALR","sourcesContent":["// ==========================================================================\r\n// Component: Flags-menu.component\r\n// ==========================================================================\r\n.flags {\r\n\r\n    img {\r\n        vertical-align: middle;\r\n        margin-right: 8px;\r\n    }\r\n\r\n    .mat-menu-item,\r\n    .mat-mdc-menu-item {\r\n        height: 36px;\r\n        line-height: 36px;\r\n        font-size: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
